import dayjs from 'dayjs';

export const parsePhoneNumber = (input?: string) => {
  if (!input) return '';

  const numbers = input.replace(/[^\d-]/g, '').replace(/(\-)/g, '');

  if (numbers.startsWith('02')) {
    if (numbers.length <= 2) return numbers;
    if (numbers.length <= 6) return `${numbers.slice(0, 2)}-${numbers.slice(2)}`;
    return `${numbers.slice(0, 2)}-${numbers.slice(2, 6)}-${numbers.slice(6, 10)}`;
  }

  if (numbers.length <= 3) return numbers;
  if (numbers.length <= 7) return `${numbers.slice(0, 3)}-${numbers.slice(3)}`;
  return `${numbers.slice(0, 3)}-${numbers.slice(3, 7)}-${numbers.slice(7, 11)}`;
};

export const parseBusinessNumber = (input?: string) => {
  if (!input) return '';

  const newValue = input.replace(/[^\d-]/g, '').replace(/(\-)/g, '');

  if (newValue.length <= 3) return newValue;
  if (newValue.length <= 5) return `${newValue.slice(0, 3)}-${newValue.slice(3)}`;

  return `${newValue.slice(0, 3)}-${newValue.slice(3, 5)}-${newValue.slice(5, 10)}`;
};

// YYYY-MM-DD -> YYMMDD
export const parseBirthDate = (input?: string) => {
  if (!input) return;
  if (dayjs(input).isBefore('1900-01-01')) return '';
  if (input === '0000-00-00') return '';

  const _input = input.replace(/-/g, '');
  const __input = _input.slice(2);
  return __input;
};

// YYMMDD + gender -> YYYY-MM-DD
// 내국인: 1,2 = 1900년대, 3,4 = 2000년대
// 외국인: 5,6 = 1900년대, 7,8 = 2000년대
export const formatBirthDateWithGender = (yymmdd?: string, gender?: string): string => {
  if (!yymmdd || yymmdd.length !== 6) return '';
  if (!gender) return '';

  const genderNum = parseInt(gender, 10);
  const yy = yymmdd.slice(0, 2);
  const mm = yymmdd.slice(2, 4);
  const dd = yymmdd.slice(4, 6);

  // 1,2,5,6: 1900년대 / 3,4,7,8: 2000년대
  const century = [1, 2, 5, 6].includes(genderNum) ? '19' : '20';
  const yyyy = `${century}${yy}`;

  return `${yyyy}-${mm}-${dd}`;
};

export const parseGenderNumber = (input?: string) => {
  if (!input) return;

  const numbers = input.replace(/[^\d]/g, '');
  if (numbers.length === 0) return '';
  return numbers.at(-1);
};

export const removeSpace = (input: string) => {
  return input.replace(/ /g, '');
};

// 2024-12-31 포맷
// 숫자만 입력 -> 포맷은 - 자동 추가 / 제거
export const parseOpenDate = (input?: string) => {
  if (!input) return '';

  if (input.length === 5 && input.endsWith('/')) return input;
  if (input.length === 8 && input.endsWith('/')) return input;

  const numbers = input.replace(/[^\d]/g, '');

  if (numbers.length <= 4) return numbers;

  if (numbers.length <= 6) return `${numbers.slice(0, 4)}/${numbers.slice(4)}`;

  return `${numbers.slice(0, 4)}/${numbers.slice(4, 6)}/${numbers.slice(6, 8)}`;
};

export const isValidOpenDate = (dateString: string): boolean => {
  const regex = /^\d{4}\/\d{2}\/\d{2}$/;
  if (!regex.test(dateString)) return false;

  const [year, month, day] = dateString.split('/').map(Number);
  if (month < 1 || month > 12) return false;
  if (day < 1 || day > 31) return false;

  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
};

export const isValidPhoneNumber = (phoneNumber: string): boolean => {
  const regex = /^\d{3}-\d{4}-\d{4}$/;
  return regex.test(phoneNumber);
};
